/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Social_LinksInputs */

const en_common_social_links = /** @type {(inputs: Common_Social_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social links`)
};

const es_common_social_links = /** @type {(inputs: Common_Social_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlaces sociales`)
};

/**
* | output |
* | --- |
* | "Social links" |
*
* @param {Common_Social_LinksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_social_links = /** @type {((inputs?: Common_Social_LinksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Social_LinksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_social_links(inputs)
	return es_common_social_links(inputs)
});